import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect } from 'react';
export function useEmbeddedCommentClickListener(t0) {
  "use memo";

  const $ = _c(12);
  const {
    onUpdateCollaborationSidebarState,
    isOpen,
    prevIsOpen
  } = t0;
  let t1;
  if ($[0] !== onUpdateCollaborationSidebarState) {
    t1 = e => {
      onUpdateCollaborationSidebarState({
        commentableAreaClickCoordinates: {
          x: e.pageX,
          y: e.pageY
        }
      });
    };
    $[0] = onUpdateCollaborationSidebarState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onWindowClick = t1;
  let t2;
  let t3;
  if ($[2] !== isOpen || $[3] !== onWindowClick || $[4] !== prevIsOpen) {
    t2 = () => {
      if (isOpen && !prevIsOpen) {
        window.addEventListener("click", onWindowClick);
      }
    };
    t3 = [isOpen, prevIsOpen, onWindowClick];
    $[2] = isOpen;
    $[3] = onWindowClick;
    $[4] = prevIsOpen;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== isOpen || $[8] !== onWindowClick || $[9] !== prevIsOpen) {
    t4 = () => {
      if (!isOpen && prevIsOpen) {
        window.removeEventListener("click", onWindowClick);
      }
    };
    t5 = [isOpen, prevIsOpen, onWindowClick];
    $[7] = isOpen;
    $[8] = onWindowClick;
    $[9] = prevIsOpen;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
}